import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// -------------------------------------------------------------------------------------------------------------------
// ESTILOS
// -------------------------------------------------------------------------------------------------------------------

const Galeria = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => props.columnas}, minmax(0, 1fr));
    gap: 10px;
    width: 100%;
`;


const ImagenContenedor = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
    cursor: pointer;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;

    &:hover {
        border-color: #999;
    }
`;


const Imagen = styled.img`
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: contain;
    display: block;
    background: #f5f5f5;
`;


const Informacion = styled.div`
    padding: 5px 7px;
    overflow: hidden;
`;


const NombreArchivo = styled.div`
    font-size: 12px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;


const Descripcion = styled.div`
    font-size: 12px;
    color: #666;
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;


const Visor = styled.div`
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    background: rgba(0, 0, 0, 0.8);

    padding: 30px;
`;


const ImagenGrande = styled.img`
    max-width: 95vw;
    max-height: 95vh;
    object-fit: contain;
`;


const BotonCerrar = styled.button`
    position: absolute;
    top: 15px;
    right: 20px;

    width: 40px;
    height: 40px;

    border: 0;
    border-radius: 50%;

    background: rgba(255, 255, 255, 0.9);

    font-size: 25px;
    line-height: 40px;

    cursor: pointer;
`;

// -------------------------------------------------------------------------------------------------------------------
// CLASE
// -------------------------------------------------------------------------------------------------------------------

class GaleriaImagenes extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            imagenSeleccionada: null
        };
    }

    seleccionarImagen = (dato) => {
        const {
            campoUrl,
            campoNombreArchivo,
            campoDescripcion
        } = this.props;

        this.setState({
            imagenSeleccionada: {
                url: dato[campoUrl],
                nombreArchivo: dato[campoNombreArchivo],
                descripcion: dato[campoDescripcion]
            }
        });
    };

    cerrarVisor = () => {
        this.setState({
            imagenSeleccionada: null
        });
    };

    clickVisor = (e) => {
        // Solo cerramos si se ha pulsado sobre el fondo
        if (e.target === e.currentTarget) {
            this.cerrarVisor();
        }
    };

    render() {
        const { datos, campoUrl, campoNombreArchivo, campoDescripcion, columnas } = this.props;
        const { imagenSeleccionada} = this.state;

        return (
            <>
                <Galeria columnas={columnas}>
                    {datos.map((dato, index) => {
                        const url = dato[campoUrl];
                        const nombreArchivo = dato[campoNombreArchivo];
                        const descripcion = dato[campoDescripcion];
                        return (
                            <ImagenContenedor
                                key={index}
                                onClick={() => this.seleccionarImagen(dato)}
                            >
                                <Imagen src={url} alt={descripcion || nombreArchivo || "" } />
                                <Informacion>
                                    {nombreArchivo && ( <NombreArchivo title={nombreArchivo}> {nombreArchivo} </NombreArchivo>)}
                                    {descripcion && ( <Descripcion title={descripcion}> {descripcion} </Descripcion> )}
                                </Informacion>
                            </ImagenContenedor>
                        );
                    })}
                </Galeria>

                {imagenSeleccionada && (
                    <Visor onClick={this.clickVisor}>
                        <BotonCerrar type="button"  onClick={this.cerrarVisor}> × </BotonCerrar>
                        <ImagenGrande src={imagenSeleccionada.url} alt={imagenSeleccionada.descripcion || imagenSeleccionada.nombreArchivo || "" } />
                    </Visor>
                )}
            </>
        );
    }
}


GaleriaImagenes.propTypes = {
    datos: PropTypes.array.isRequired,
    campoUrl: PropTypes.string.isRequired,
    campoNombreArchivo: PropTypes.string.isRequired,
    campoDescripcion: PropTypes.string.isRequired,
    columnas: PropTypes.number
};

GaleriaImagenes.defaultProps = {
    columnas: 4
};

export default GaleriaImagenes;